import React, { lazy, useEffect, useState } from 'react';
import Tab from 'react-bootstrap/Tab';
import { Col, Row } from 'react-bootstrap';
import Tabs from 'react-bootstrap/Tabs';
import Form from 'react-bootstrap/Form';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { SpinnerDotted } from 'spinners-react';
import envValues from '../../enviornment';

import TableComponent from '../OneRepTable/OneRepTable';
import { getCookies } from '../../hooks/useCookies';

const OneRepChart = lazy(() => import('../Chart/OneRepChart'));

function oneRepMaxComponent() {
  const { userId } = useParams();

  const token = `Bearer ${getCookies('Token')}`;

  const [dropdownData, setDropdownData] = useState([]);
  const [graphData, setGraphData] = useState([]);

  const [excersize, setExcersize] = useState('Overhead Press');
  const [filter, setFilter] = useState('weekly');
  const [overviewData, setOverviewData] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const [weightUnit, setWeightUnit] = useState('');

  const getDropdownData = async () => {
    try {
      const response = await axios.get(
        `${envValues.REACT_APP_API_ENDPOINT}/statistics/1rm-exercises`,
        {
          headers: {
            Authorization: `${token}`,
            'Content-Type': 'application/json',
          },
        }
      );

      setDropdownData(response.data.data.exercises);
    } catch (error) {
      console.log(error, 'err in drop');
    }
  };

  const getOneRepMaxData = async (selectedFilter) => {
    try {
      setIsLoading(true);

      const response = await axios.get(
        `${envValues.REACT_APP_API_ENDPOINT}/statistics/1rm-overview/${userId}?filter=${selectedFilter}&exercise=${excersize}`,
        {
          headers: {
            Authorization: `${token}`,
            'Content-Type': 'application/json',
          },
        }
      );
      setWeightUnit(response.data.data.weightUnit);
      setGraphData(response.data.data.graphData);
      setOverviewData(response.data.data.rmOverview);
      setIsLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getOneRepMaxData(filter);
  }, [filter, excersize]);

  useEffect(() => {
    getDropdownData();
  }, []);

  return (
    <div>
      {' '}
      <div className="inner_tab_head">
        <Tabs
          defaultActiveKey="weekly"
          id="justify-tab-example"
          className="mb-3"
          justify
          onSelect={(key) => key && setFilter(key)}
        >
          <Tab eventKey="weekly" title="Week">
            <div className="resp_table">
              <div className="table_select">
                <Form.Select
                  aria-label="Select Body Part"
                  value={excersize}
                  onChange={(e) => setExcersize(e.target.value)}
                >
                  {dropdownData?.map((bodyItem) => (
                    <option key={bodyItem.exerciseName} value={bodyItem.exerciseName}>
                      {bodyItem.exerciseName}
                    </option>
                  ))}
                </Form.Select>
              </div>
              {isLoading ? (
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '50vh',
                  }}
                >
                  <SpinnerDotted style={{ color: '#207a4a' }} />
                </div>
              ) : (
                <>
                  <div className="overview_outer">
                    <div className="col-md-12">
                      <div className="row">
                        <div className="col-md-12 mb-3">
                          <h3>Overview</h3>
                        </div>
                        <div className="col-md-3">
                          <h5>Total Sets</h5>
                          <p>{overviewData?.totalSets}</p>
                        </div>
                        <div className="col-md-3">
                          <h5>Average Reps Per Set</h5>
                          <p>{overviewData?.avgReps?.toFixed(2)}</p>
                        </div>
                        <div className="col-md-3">
                          <h5>Average Weight Per Set</h5>
                          <p>{overviewData?.avgWeight?.toFixed(2)}</p>
                        </div>
                        <div className="col-md-3">
                          <h5>Average % 1RM</h5>
                          <p>{overviewData?.avgOneRmPercentage?.toFixed(2)}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <Row>
                    <Col lg={6} className="mb-3">
                      <h3 className="graph_sectionh3">1RM Progress</h3>
                    </Col>
                    <Col lg={6} className="mb-3">
                      <div className="dot_section d-flex gap-2 justify-content-end align-items-center">
                        <svg
                          width="21"
                          height="22"
                          viewBox="0 0 21 22"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <ellipse cx="10.905" cy="11" rx="10.0378" ry="10.0982" fill="#E7EDE7" />
                          <path
                            d="M14.8129 11.001C14.8129 13.1803 13.0581 14.9391 10.9031 14.9391C8.74808 14.9391 6.99321 13.1803 6.99321 11.001C6.99321 8.82176 8.74808 7.06303 10.9031 7.06303C13.0581 7.06303 14.8129 8.82176 14.8129 11.001Z"
                            fill="#228B22"
                            stroke="white"
                          />
                        </svg>

                        <p className="graph_sectionp">1RM</p>
                      </div>
                    </Col>
                  </Row>
                  <OneRepChart chartData={graphData} filter={filter} unit={weightUnit} />
                  <Row>
                    <Col lg={12} className="mb-3">
                      <div className="graph_sectionn dot_section d-flex gap-2 justify-content-end align-items-center">
                        {/* <p>Note: 1 ton = 2,000 lbs</p> */}
                      </div>
                    </Col>
                  </Row>
                </>
              )}
              <TableComponent unit={weightUnit} />
            </div>
          </Tab>
          <Tab eventKey="monthly" title="Month">
            <div className="resp_table">
              <div className="table_select">
                <Form.Select
                  aria-label="Select Body Part"
                  value={excersize}
                  onChange={(e) => setExcersize(e.target.value)}
                >
                  {dropdownData?.map((bodyItem) => (
                    <option key={bodyItem.exerciseName} value={bodyItem.exerciseName}>
                      {bodyItem.exerciseName}
                    </option>
                  ))}
                </Form.Select>
              </div>
              {isLoading ? (
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '50vh',
                  }}
                >
                  <SpinnerDotted style={{ color: '#207a4a' }} />
                </div>
              ) : (
                <>
                  <div className="overview_outer">
                    <div className="col-md-12">
                      <div className="row">
                        <div className="col-md-12 mb-3">
                          <h3>Overview</h3>
                        </div>
                        <div className="col-md-3">
                          <h5>Total Sets</h5>
                          <p>{overviewData?.totalSets}</p>
                        </div>
                        <div className="col-md-3">
                          <h5>Average Reps Per Set</h5>
                          <p>{overviewData?.avgReps?.toFixed(2)}</p>
                        </div>
                        <div className="col-md-3">
                          <h5>Average Weight Per Set</h5>
                          <p>{overviewData?.avgWeight?.toFixed(2)}</p>
                        </div>
                        <div className="col-md-3">
                          <h5>Average % 1RM</h5>
                          <p>{overviewData?.avgOneRmPercentage?.toFixed(2)}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="graph_section">
                    <div className="col-md-12 mb-3">
                      <h3>1RM Progress</h3>
                    </div>
                    <OneRepChart chartData={graphData} filter={filter} unit={weightUnit} />
                  </div>
                </>
              )}
              <TableComponent unit={weightUnit} />
            </div>
          </Tab>
          <Tab eventKey="yearly" title="Year">
            <div className="resp_table">
              <div className="table_select">
                <Form.Select
                  aria-label="Select Body Part"
                  value={excersize}
                  onChange={(e) => setExcersize(e.target.value)}
                >
                  {dropdownData?.map((bodyItem) => (
                    <option key={bodyItem.exerciseName} value={bodyItem.exerciseName}>
                      {bodyItem.exerciseName}
                    </option>
                  ))}
                </Form.Select>
              </div>
              {isLoading ? (
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '50vh',
                  }}
                >
                  <SpinnerDotted style={{ color: '#207a4a' }} />
                </div>
              ) : (
                <>
                  <div className="overview_outer">
                    <div className="col-md-12">
                      <div className="row">
                        <div className="col-md-12 mb-3">
                          <h3>Overview</h3>
                        </div>
                        <div className="col-md-3">
                          <h5>Total Sets</h5>
                          <p>{overviewData?.totalSets}</p>
                        </div>
                        <div className="col-md-3">
                          <h5>Average Reps Per Set</h5>
                          <p>{overviewData?.avgReps?.toFixed(2)}</p>
                        </div>
                        <div className="col-md-3">
                          <h5>Average Weight Per Set</h5>
                          <p>{overviewData?.avgWeight?.toFixed(2)}</p>
                        </div>
                        <div className="col-md-3">
                          <h5>Average % 1RM</h5>
                          <p>{overviewData?.avgOneRmPercentage?.toFixed(2)}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="graph_section">
                    <div className="col-md-12 mb-3">
                      <h3>1RM Progress</h3>
                    </div>
                    <OneRepChart chartData={graphData} filter={filter} unit={weightUnit} />
                  </div>
                </>
              )}
              <TableComponent unit={weightUnit} />
            </div>
          </Tab>
          <Tab eventKey="all" title="Lifetime">
            <div className="resp_table">
              <div className="table_select">
                <Form.Select
                  aria-label="Select Body Part"
                  value={excersize}
                  onChange={(e) => setExcersize(e.target.value)}
                >
                  {dropdownData?.map((bodyItem) => (
                    <option key={bodyItem.exerciseName} value={bodyItem.exerciseName}>
                      {bodyItem.exerciseName}
                    </option>
                  ))}
                </Form.Select>
              </div>
              {isLoading ? (
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '50vh',
                  }}
                >
                  <SpinnerDotted style={{ color: '#207a4a' }} />
                </div>
              ) : (
                <>
                  <div className="overview_outer">
                    <div className="col-md-12">
                      <div className="row">
                        <div className="col-md-12 mb-3">
                          <h3>Overview</h3>
                        </div>
                        <div className="col-md-3">
                          <h5>Total Sets</h5>
                          <p>{overviewData?.totalSets}</p>
                        </div>
                        <div className="col-md-3">
                          <h5>Average Reps Per Set</h5>
                          <p>{overviewData?.avgReps?.toFixed(2)}</p>
                        </div>
                        <div className="col-md-3">
                          <h5>Average Weight Per Set</h5>
                          <p>{overviewData?.avgWeight?.toFixed(2)}</p>
                        </div>
                        <div className="col-md-3">
                          <h5>Average % 1RM</h5>
                          <p>{overviewData?.avgOneRmPercentage?.toFixed(2)}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="graph_section">
                    <div className="col-md-12 mb-3">
                      <h3>1RM Progress</h3>
                    </div>
                    <OneRepChart chartData={graphData} filter={filter} unit={weightUnit} />
                  </div>
                </>
              )}
              <TableComponent unit={weightUnit} />
            </div>
          </Tab>
        </Tabs>
      </div>
    </div>
  );
}

export default oneRepMaxComponent;
